import { AbstractDialogContent } from '@abstracts/dialog/dialog-content';
import { Injector } from '@angular/core';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Transaction } from '@models/transaction';
import { TransactionDto } from '@dto/transactionDto';
import { TransactionSuccess } from '@enums/transaction-success.enum';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TransactionsService } from '@services/entity/transactions.service';
import { FilesService } from '@services/files/files.service';
import { FormService } from '@services/form/form.service';

@Component({
  selector: 'app-details-running-transaction-dialog-content',
  templateUrl: './details-running-transaction-dialog-content.component.html',
  styleUrls: ['./details-running-transaction-dialog-content.component.scss']
})
export class DetailsRunningTransactionDialogContentComponent extends AbstractDialogContent implements OnInit {

  public className = 'DetailsRunningTransactionDialogContentComponent';

  @ViewChild('detailsRunningTransaction') detailsTransaction;

  public entity: TransactionDto;

  public customerId: number;

  public fileExists: boolean;

  constructor(
    public activeModal: NgbActiveModal,
    public transactionsService: TransactionsService,
    public formService: FormService,
    private filesService: FilesService,
    injector: Injector) {
    super(activeModal, injector);
  }


  ngOnInit() {
    super.ngOnInit();
  }

  onEntityLoadedEvent(entity: TransactionDto) {
    this.entity = entity;
    this.entity.successMessage = TransactionSuccess[entity.success];
    this.checkIfFileExists();
  }

  checkIfFileExists() {
    var fileName = 'signedMeterValues/' + this.entity.id + '-signedMeterValue.xml';

    this.filesService.fileExists(fileName).subscribe(result => {
      this.fileExists = result;
    })
  }

  downloadSignedMeterValues() {
    if (this.fileExists) {
      var fileName = 'signedMeterValues/' + this.entity.id + '-signedMeterValue.xml';
      var downloadFileName = this.entity.id + '-signedMeterValue.xml';
      this.filesService.download(fileName, downloadFileName);
    }
  }
}
